module.exports = __webpack_public_path__ + "img/678CBAD8.fd2381a5.png";